import Home from '@/components/home.vue'
import Profile from '@/components/profile.vue'
import Team from '@/components/team.vue'
import Challenge from '@/components/challenge.vue'
import ChallengeInfo from '@/components/challenge_info.vue'
import Rank from '@/components/rank.vue'
import News from '@/components/news.vue'
import Register from '@/components/register.vue'
import Login from '@/components/login.vue'
import CreateTeam from '@/components/create_team.vue'
import ChangePwd from '@/components/change_pwd.vue'
import Trend from '@/components/trend.vue'
import NewsDetail from '@/components/news_detail.vue'
// import Scoreboard from '@/components/scoreboard.vue'
import ForgetPwd from '@/components/forget_pwd.vue'

export default {
  mode: 'history',
  routes: [
    {
      path: '/',
      alias: '/about',
      component: Home
    },
    {
      path: '/profile',
      component: Profile
    },
    {
      path: '/team/:tid',
      component: Team
    },
    {
      path: '/team',
      redirect: '/team/_'
    },
    {
      path: '/challenge',
      component: Challenge
    },
    {
      path: '/challenge/:pid',
      component: ChallengeInfo
    },
    {
      path: '/rank',
      component: Rank
    },
    {
      path: '/news',
      component: News
    },
    {
      path: '/register',
      component: Register
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/createTeam',
      component: CreateTeam
    },
    {
      path: '/changePwd',
      component: ChangePwd
    },
    {
      path: '/trend',
      component: Trend
    },
    {
      path: '/news_detail/:nid',
      component: NewsDetail
    },
    // {
    //   path: '/scoreboard',
    //   component: Scoreboard
    // },
    {
      path: '/forgetPwd',
      component: ForgetPwd
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/index.js